import { cn } from "@gettactic/helpers";
import React from "react";
import { useFormControlWrapper } from "./FormControlWrapperProvider";

export const FormControlOutline: React.FC = () => {
  const { isInvalid } = useFormControlWrapper();
  const isInvisible = !isInvalid;
  let ring = "ring-primary";
  if (isInvalid) {
    ring = "ring-red-700";
  }
  return (
    <div
      className={cn(
        "nvst-form-control-wrapper-outline",
        "pointer-events-none absolute inset-0 z-0 rounded-md ring-2",
        isInvisible ? "invisible" : "visible",
        ring
      )}
    />
  );
};
